<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	.row
		.col-md-3
			select-form(v-model='filtro.categoria', :value='filtro.categoria', name='Categoria', :url='`/categorias?ativo=1`', id='id', titulo='title' optionText="Todos" :session="true")
		.col-md-4
			input-form-text(textInput='Título', :required='true', v-model='filtro.title', :value='filtro.title' :layout="false")
		.col-md-4
		.col-md-1
			br
			button.btn.btn-primary(@click.prevent='getLimparFiltro') Limpar
	br
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(
		ref="grid"
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
		:DSfilter="filter"
		:DSserverFiltering="true"
	)
</template>

<script>
import Vue from 'vue'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate'
import Permission from '@/mixins/Permission'
import TemplateCapa from './TemplateCapa'

import InputFormText from '@/components/form/InputForm'
import SelectForm from '@/components/form/SelectForm'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'

import moment from 'moment'

export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid,
		InputFormText,
		SelectForm
	},
	computed: {
		filter() {
			return {
				logic: 'and',
				filters: [
					{
						field: 'categoria',
						operator: 'contains',
						value: this.filtro.categoria
					},
					{
						field: 'title',
						operator: 'contains',
						value: this.filtro.title
					}
				],
				serverDateTime: null,
			}
		},
		urlDataSource() {
			return `${this.$url}/noticias/all?destaque=8`
		}
	},
	watch: {
		'filtro.categoria'() {
			this.setFiltro()
		},
		'filtro.title'() {
			this.setFiltro()
		}
	},
	data() {
		return {
			title: 'Notícias',
			titleNew: '',
			url: '/sistema/noticias/',
			columns: [{
				template: this.getTemplateCapa,
				title: 'Capa',
				width: 40,
			}, {
				field: 'datanot',
				title: 'Data',
				width: 50
			}, {
				field: 'timenot',
				title: 'Hora',
				width: 50
			},
			{
				title: 'Título',
				width: 200,
				template: (e) => {
					if (!e) return ''
					if (e.programada) {
						return `<span style="background-color:#ffeeba; color:#856404; font-size:10px; padding:2px 6px; border-radius:3px; margin-right:5px; display:inline-block;">Programada</span> ${e.title}`
					}
					return `${e.title}`
				}
			},

			{
				field: 'categoria_name',
				title: 'Categoria',
				width: 200
			}, {
				field: 'active_nome',
				title: 'Ativo',
				width: 120
			},
			{
				title: 'Destaque',
				width: 130,
				template: this.getTemplateDestaque
			}
			],
			filtro: {
				categoria: null,
				title: null,
			},
			isActive: false,
		}
	},
	methods: {
		parse(d) {

			d.data.map(i => {
				i.timenot = moment(new Date(`${i.datanot} ${i.timenot}`)).format('HH:mm')
				i.datanot = moment(i.datanot).format('DD/MM/YYYY')
				const noticiaDateTime = moment(`${i.datanot.split('/').reverse().join('-')} ${i.timenot}`, 'YYYY-MM-DD HH:mm')

				i.programada = noticiaDateTime.isAfter(this.serverDateTime)

				return i
			})
			return d
		},
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		getTemplateCapa(e) {
			return {
				template: TemplateCapa,
				templateArgs: {
					data: e
				}
			}
		},
		getTemplateTitle(e) {
			if (!e) return '' // Proteção extra
			if (e.programada) {
				return '[Programada] ' + e.title
			}
			return e.title
		},
		getTemplateDestaque(e) {
			var vm = this
			return {
				template: Vue.component('destaque-template', {
					template: `
            <div>
              <div v-if="isDestaque">
                <button
                  @click.prevent="removerDestaque"
                  class="btn btn-sm btn-secondary"
                  title="Remover Destaque"
                >
                  Remover Destaque
                </button>
              </div>
              <div v-else>
                <button
                  @click.prevent="tornarDestaque"
                  class="btn btn-sm btn-primary"
                  title="Tornar Destaque"
                >
                  Tornar Destaque
                </button>
              </div>
            </div>
          `,
					data() {
						return {
							templateArgs: {},
						}
					},
					computed: {
						isDestaque() {
							return this.templateArgs.ordenar >= 1 && this.templateArgs.ordenar <= 5
						}
					},
					methods: {
						async tornarDestaque() {
							await vm.destacarNoticia(this.templateArgs)
						},
						async removerDestaque() {
							await vm.removerDestaqueNoticia(this.templateArgs)
						}
					}
				}),
				templateArgs: e
			}
		},
		setFiltro() {
			let filtro = {
				categoria: this.filtro.categoria,
				title: this.filtro.title,
			}
			localStorage.setItem('_filtroNoticias', JSON.stringify(filtro))
		},
		getLimparFiltro() {
			let filtro = {
				categoria: null,
				title: null,
			}
			localStorage.setItem('_filtroNoticias', JSON.stringify(filtro))
			this.filtro = filtro
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.title, 'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if (result.isConfirmed) {
				this.isActive = true
				await req(`/noticias/${item.id}`, 'delete').catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		},
		async getServerDateTime() {
			try {
				const response = await req('/date', 'get')
				if (response.date && response.time) {
					this.serverDateTime = moment(response.datetime, 'YYYY-MM-DD HH:mm:ss')
				} else {
					// eslint-disable-next-line no-console
					console.error('Formato inesperado ao buscar data/hora do servidor', response)
				}

			} catch (error) {
				// eslint-disable-next-line no-console
				console.error('Erro ao buscar data/hora do servidor', error)
			}
		},
		async destacarNoticia(item) {
			try {
				this.isActive = true
				await req(`/noticias/add-destaques/${item.id}`, 'post')
				sucesso('Notícia destacada com sucesso!')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			} catch (error) {
				erro('Erro ao destacar notícia')
			} finally {
				this.isActive = false
			}
		},
		async removerDestaqueNoticia(item) {
			try {
				this.isActive = true
				await req(`/noticias/remover-destaques/${item.id}`, 'post')
				sucesso('Destaque removido com sucesso!')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			} catch (error) {
				erro('Erro ao remover destaque')
			} finally {
				this.isActive = false
			}
		},

	},
	created() {
		this.verifPermissao()
		this.getServerDateTime()
		let filtro = localStorage.getItem('_filtroNoticias')
			? JSON.parse(localStorage.getItem('_filtroNoticias'))
			: null
		if (filtro) {
			this.filtro = filtro
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
